export const version = "wordlists/5.5.0";
//# sourceMappingURL=_version.js.map